<section 
  class="content-layout" 
  [brightsideWebFb]="{ event_name: 'survey_completed' }"  
>
  <bw-action-article-legacy>
    <div content-section>
      <div class="flex-column mb-sm">
        <div class="align-left">
          <img src="../assets/survey-completed.svg" alt="survey_completed" class="mb-md" />
          <p title-medium class="mb-sm">{{ 'SURVEY_COMPLETE_TITLE' | translate }}</p>
          <typography-legacy text-large-regular color="var(--secondary-text)">
            <p class="left" style="max-width: 432px;">
              {{ 'SURVEY_COMPLETE_DESC' | translate }}
            </p>
          </typography-legacy>
        </div>
      </div>
    </div>

    <div footer-actions>
      <button        
        bw-button-legacy
        type="submit"
        [brightsideWebFb]="{ event_name: 'survey_completed' }"
        (click)="handleSurveyCompleted()"
      >
        {{ 'SURVEY_COMPLETE_CTA' | translate }}
      </button>
    </div>
  </bw-action-article-legacy>
</section>
